<div [ngClass]="className" [@drawerAnimation]="true">
    <mat-toolbar *ngIf="title">
        <span class="fill-remaining-space">{{title}}</span>
        <button *ngIf="hasCloseButton" mat-icon-button class="action" (click)="onCloseClick()">
            <mat-icon aria-label="Actions">close</mat-icon>
        </button>
    </mat-toolbar>
    <div class="container">
        <div class="row">
            <div class="col py-2" [ngSwitch]="renderMethod">
                <div *ngSwitchCase="'text'" [innerHTML]="content"></div>
                <ng-container *ngSwitchCase="'template'">
                    <ng-container *ngTemplateOutlet="content; context: context"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'component'">
                    <ng-container *ngComponentOutlet="content"></ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>
